import Swiper from "swiper";
import {MD_WIDTH} from "@main/helpers/const";
import {ToggleScroll} from "@main/components/toggle-scroll";

class SlidesModal {
    constructor(el) {
        this.el = el;
        this.links = this.el.querySelectorAll(".js-slides-for-modal-link");
        this.modal = document.querySelector(".js-modal-slider[data-modal='" + this.el.dataset.modal + "']");
        this.modalDomSwiper = this.modal.querySelector(".js-modal-slider-swiper");
        this.documentEl = document.body;
        this.initSwiper();
        this.initEvents();
    }

    initSwiper() {
        this.modalSwiper = new Swiper(this.modalDomSwiper, {
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            initialSlide: 1,
            watchActiveIndex: true,
            slideToClickedSlide: true,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 11
                }
            }
        });
    }

    initEvents() {
        document.addEventListener("click", (e) => {
            const textBLock = e.target.classList.contains("js-modal-slider-text") || e.target.closest(".js-modal-slider-text");
            if (textBLock) {
                this.toggleText(textBLock);
            }
        });

        this.links.forEach((link, index )=> {
            link.addEventListener("click", e => {
                e.preventDefault();
                this.modalSwiper.slideTo(index);
                this.modal.classList.add("shown");
                ToggleScroll.disable(this.modal);
            });
        });
    }

    toggleText(textBLock) {
        if (!textBLock) {
            return;
        }
        if (textBLock.classList.contains("opened")) {
            textBLock.classList.remove("opened");
        } else {
            const inner = textBLock.querySelector(".js-modal-slider-text-inner");
            if (!inner) {
                return;
            }
            if (inner.scrollHeight > inner.clientHeight) {
                textBLock.classList.add("opened");
            }
        }
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-slides-for-modal")
        .forEach(slider => new SlidesModal(slider));
});
